import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import Card from '@mui/material/Card';
import * as React from 'react';
import { getFilters, getFiltersNew, getLocationQueueCounter, getQueueCounter } from '../../../services/api-service';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import OZTable from '../../OZTable/OZTable';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import WidgetGraph from '../../Widget-Graph/Widget-Graph';
import useChartResize from '../../../hooks/useChartResize';

import { Badge, Box, Chip, Stack, Grid } from '@mui/material';
import { WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import '../LocationQueueCounter/LocationQueueCounter.css';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import { mapRowDataWithThreshold, mapRowDataWithThresholdNew } from '../../../utils/util';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';


const thresholdFields = [
	{ label: 'Longest wait time', value: '', key: 'LongestWaitTime', condition: 'GREATER_THAN' },
	{ label: 'Calls Waiting', value: '', key: 'QueueCount', condition: 'GREATER_THAN' }
];

export default function LocationQueueCounter(props: any) {
	const { useState, useRef } = React;
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || 4);
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [responseLength, setresponseLength] = useState<Number>(0);
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columnData, setColumnData] = useState<Array<any>>([]);
	const [thresholdItems, setThresholdItems] = useState<Array<any>>([]);
	const [locationQueueCounterFilter, setLocationQueueCounterFilter] = useState<Array<any>>(props?.selectedFilters?.filters || []);
	const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const [savedThresholdList, setSavedThresholdList] = useState<any>({
		thresholdList: props?.selectedThresholds?.thresholdList?.length ? props?.selectedThresholds?.thresholdList : [],
		showSkillList: props?.selectedThresholds?.showSkillList || false
	});
	const downloadContent = useRef<null | any>(null);
	const { chartContainerRef, chartDimensions } = useChartResize();

	const intervalRef = useRef<any>(null);
	const isWidgetDataLoadingRef = useRef<boolean>(false);

	React.useEffect(() => {
		if (savedThresholdList && savedThresholdList.thresholdList && savedThresholdList.thresholdList.length) {
			console.log('thresholdItems savedThresholdList useEffect', savedThresholdList);
			setThresholdItems(savedThresholdList.thresholdList);
		}
	}, [savedThresholdList.thresholdList]);

	const retrieveTableData = async (filters = '0') => {
		try {
			if (isWidgetDataLoadingRef.current) {
				console.log('Widget data fetch already in progress, skipping this cycle LocationQueueCounter');
				return;
			};
			isWidgetDataLoadingRef.current = true;
			const columns = [
				{ name: 'Skill Location', key: 'LocationName' },
				{ name: 'Skill Details', key: 'SkillDetail1' },
				{ name: 'Calls Waiting', key: 'QueueCount' },
			];
			const rows: any = await getLocationQueueCounter({ filters, type: filterType });
			console.log("here the response ", rows);
			// const updatedRowData = mapRowDataWithThreshold(thresholdItems, rows);
			const updatedRowData = mapRowDataWithThresholdNew(thresholdItems, rows);
			setRowData(updatedRowData);
			setColumnData(columns);
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		}
		catch (error) {
			console.error('Error fetching location queue counter:', error);
		}
		finally {
			isWidgetDataLoadingRef.current = false;
		}
	};

	const handleDownload = (type: string) => {
		console.log(type);
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const handleFilterDelete = (id: Number) => {
		const newFilter = locationQueueCounterFilter.filter((item: any) => item.id !== id);
		setLocationQueueCounterFilter(newFilter);
		props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId);
	};

	const clearFilter = () => {
		console.info('Clear all filter.');
		setLocationQueueCounterFilter([]);
		props?.handleFilterChange?.([], filterSection, props?.widgetId);
	};

	const handleFilterExistingData = (filteredData: any) => {
		setLocationQueueCounterFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId);
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection }: any) => {
		setLocationQueueCounterFilter(selectedFilters);
		setFilterType(newFilterType);
		setFilterSection(newfilterSection);
		props?.handleFilterChange?.(selectedFilters, filterSection, props?.widgetId);
		toggleDrawer(false);
	};

	const filterItems = locationQueueCounterFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	const toggleThresholdDrawer = (isOpen: boolean, data: any = null, showSkillList: any = false) => {
		setIsThresholdDrawerOpen(isOpen);
		if (data) {
			const savedThresholdList = structuredClone(data);
			setSavedThresholdList((prev: any) => ({
				showSkillList: showSkillList,
				thresholdList: savedThresholdList
			}));
			if (props?.handleThresholdChange) {
				props.handleThresholdChange?.(savedThresholdList, showSkillList, props?.widgetId);
			}
			setThresholdItems(data);
		}
	};

	const updateThresholdItems = async () => {
		let newThresholdItems = [];
		const response: any = await getFilters('Location');
		newThresholdItems.push({ label: 'Organization Level', fields: thresholdFields, isOrgSkill: true });
		for (const row of response) {
			if (row.name !== 'All') {
				newThresholdItems.push({ label: row.Name, key: 'SkillName', value: row.Name, fields: thresholdFields });
			}
		}
		setThresholdItems(newThresholdItems);
	};

	React.useEffect(() => {
		updateThresholdItems();
		return () => {
			clearInterval(intervalRef.current);
		};
	}, []);

	React.useEffect(() => {
		// const filterIds = (agentListFilter.length && !(responseLength === agentListFilter.length)) ? agentListFilter.map((item: any) => item.id).join(',') : '0';
		const filterIds = (locationQueueCounterFilter.length && !(responseLength === locationQueueCounterFilter.length)) ? locationQueueCounterFilter.map((item: any) => item.id).join(',') : '0';
		retrieveTableData(filterIds);
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}
		intervalRef.current = setInterval(() => retrieveTableData(filterIds), WIDGET_REFRESH_INTERVAL.LOCATION_QUEUE_COUNTER);
	}, [locationQueueCounterFilter, thresholdItems]);

	function getRowData(row: any) {
		// row = row?.map((item: any) => {
		// 	let rowObj = {
		// 		...item,
		// 		SkillsFormatted: item?.AgentSkills ? item?.AgentSkills : item?.AgentSkills,
		// 		// CampaignName: item?.CampaignNameOfLastCall ? item?.CampaignNameOfLastCall : "",
		// 		// CampaignNameOfLastCall: item?.CampaignNameOfLastCall ? item?.CampaignNameOfLastCall : "",
		// 	};
		// 	return rowObj;
		// });
		return row;
	}

	return (
		<Card className="customCard">
			<div className="card-header">
				<div className="card-title">
					Location Queue Counter<div className="card-title-badge">Live</div>
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<WidgetDownload element={downloadContent} handleDownload={handleDownload} xlsx rowData={getRowData(rowData)} columns={columnData} name={'Location Queue Counter'}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={locationQueueCounterFilter.length} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
					{/* <div onClick={() => toggleThresholdDrawer(true)}>
						<WidgetGraph></WidgetGraph>
					</div> */}
				</div>
			</div>
			<FilterDrawer NewWidget isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} allowedFilters={['Location', 'Detail']} existingSelectedFilters={locationQueueCounterFilter} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} />
			<Box sx={{ width: '100%', typography: 'body1', background: "#FFFFFF" }}>
				{locationQueueCounterFilter.length > 0 && (
					<Box className='customTabPanel'>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<div className="filter-outer">
									<div className="filter-container">
										<Stack direction="row" spacing={1}>
											{filterItems}
										</Stack>
									</div>
									<div className="filter-remove" onClick={clearFilter}>
										Remove
									</div>
								</div>
							</Grid>
						</Grid>
					</Box>
				)}
			</Box>
			<Box ref={chartContainerRef} sx={{ height: locationQueueCounterFilter.length > 0 ? 'calc(100% - 118px)' : 'calc(100% - 46px)', }}>
				<OZTable columns={columnData} rows={rowData} maxHeight={360} downloadContent={downloadContent} noMaxHeight={true} height={chartDimensions.height * 1.05} />
			</Box>
			<ThresholdDrawer
				isOpen={isThresholdDrawerOpen}
				title={'Queue Counter'}
				toggleDrawer={toggleThresholdDrawer}
				thresholdItems={thresholdItems}
				savedThresholdList={savedThresholdList?.thresholdList || []}
				showSkillListByDefault={savedThresholdList.showSkillList}
			/>
		</Card>
	);
}
